import { render, staticRenderFns } from "./MorePlayers.vue?vue&type=template&id=1a54653a&"
import script from "./MorePlayers.vue?vue&type=script&lang=js&"
export * from "./MorePlayers.vue?vue&type=script&lang=js&"
import style0 from "./MorePlayers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports